import React from 'react';
import { readFile, formatFileSize } from '../util';

import styles from '../../../../stylesheet/css/header-builder/file-input.css';

const FileInput = ({ fileInfo, format, accept, onChange, onFileClick }) => {
  let message = fileInfo.name
        ? `${fileInfo.name} (${formatFileSize(fileInfo.size)})`
        : 'Choose File',
      choosingFileIsInProgress = false,
      input;

  const handleOnLinkClick = e => {
    if (choosingFileIsInProgress) {
      return;
    }

    if (!fileInfo.name) {
      input.click();
      choosingFileIsInProgress = true;
    } else {
      onFileClick(fileInfo);
    }
  };

  const handleOnChange = e => {
    let file = e.target.files[0];
    readFile(file, format, content => {
      choosingFileIsInProgress = false;
      onChange({
        name: file.name,
        type: file.type,
        size: file.size,
        content,
      });
    });
  };

  const handleOnRemoveClick = e => {
    onChange({
      name: null,
      type: null,
      size: null,
      content: null,
    });
  };

  return (
    <span className={styles.fileInput}>
      {!fileInfo.name &&
        <input type="file" className={styles.input} accept={accept} ref={el => input = el} onChange={handleOnChange} />}
      {fileInfo.name &&
        <a className={`${styles.removeBtn + ' fa fa-remove'}`} href="#" onClick={handleOnRemoveClick}></a>}
      <a className={styles.chooseBtn} href="#" onClick={handleOnLinkClick}>{message}</a>
    </span>
  );
};

export default FileInput;



// WEBPACK FOOTER //
// ./app/header-builder/components/FileInput.js